import axios from 'axios';
import { base_URL } from '../config/config';

const API_BASE_URL = `${base_URL}/api`;

export const getVenues = async (page = 3, limit = 10, filter, globalSearch = null) => {
    try {
        if(globalSearch) filter.globalSearch = { type: "user", value: globalSearch };
        if(!globalSearch || globalSearch === "") delete filter.globalSearch;
        const params = { page, limit, filter: JSON.stringify(filter) };
        const accessToken = localStorage.getItem("adminAccessToken");
        const response = await axios.get(`${API_BASE_URL}/venueform/getAllVenueForms`, {
            params,
            headers: {
                Authorization: `Bearer ${accessToken}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching venue forms:', error);
        throw error;
    }
};

export const deleteItem = async ({ category, id }) => {
    const accessToken = localStorage.getItem("adminAccessToken");
    const response = await axios.delete(`${API_BASE_URL}/venueform/deleteItem/${category}/${id}`, {
        headers: {
            Authorization: `Bearer ${accessToken}`
        }
    });
    return response.data;
};

export const getSingleVenue = async ({ category, id }) => {
    try {
        const accessToken = localStorage.getItem("adminAccessToken");
        const response = await axios.get(`${API_BASE_URL}/venueform/getSingleVeune/${category}/${id}`, {
            headers: {
                Authorization: `Bearer ${accessToken}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching onboarding details:', error);
    }
};

export const approveItem = async ({ category, id, email, name }) => {
    const accessToken = localStorage.getItem("adminAccessToken");
    const response = await axios.post(
        `${API_BASE_URL}/venueform/getApproveItem/` +
        `${encodeURIComponent(category)}/` +
        `${encodeURIComponent(id)}/` +
        `${encodeURIComponent(email)}/` +
        `${encodeURIComponent(name)}`,
        null,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        }
      );
    return response.data;
};

export const rejectItem = async ({ category, id, reasons, email, name }) => {
    const accessToken = localStorage.getItem("adminAccessToken");
    const response = await axios.post(`${API_BASE_URL}/venueform/getRejectItem/${category}/${id}`, 
        { reasons, email, name },
        {
            headers: {
                Authorization: `Bearer ${accessToken}`
            }
        }
    );
    return response.data;
};

export const searchAndFilterVenues = async ({ searchQuery = '', filter = '', page = 1, limit = 10 }) => {
    try {
        const accessToken = localStorage.getItem("adminAccessToken");
        const response = await axios.get(`${API_BASE_URL}/venueform/searchAndFilterVenues`, {
            params: { searchQuery, filter, page, limit },
            headers: {
                Authorization: `Bearer ${accessToken}`
            }
        });
        return response.data.venues;
    } catch (error) {
        console.error('Error searching and filtering venues:', error);
        throw error;
    }
};
